import { createContext, useContext } from "react";
import type { PersonioSyncRow } from "./utils";

/** Interface */
interface IPersonioSyncContext {
	onRequestLink: (row: PersonioSyncRow) => void;
	onCreateAccount: (row: PersonioSyncRow) => void;
	onReset: (row: PersonioSyncRow) => void;
}

/** Context */
export const PersonioSyncContext = createContext<IPersonioSyncContext>({
	onRequestLink: () => {},
	onCreateAccount: () => {},
	onReset: () => {},
});

/** Hooks */
export function usePersonioSyncContext() {
	return useContext(PersonioSyncContext);
}
